import React, { useState, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { isIOS } from "react-device-detect";

export default function GetLinkApp() {
  function urlTo(type) {
    if (type == "ios") {
      window.location = "https://apps.apple.com/us/app/protein/id1473589285";
    } else {
      window.location =
        "https://play.google.com/store/apps/details?id=com.protein_app_1c410.firebaseapp.base";
    }
  }
  {
    /* {

                isIOS ?
                    urlTo("ios")

                    :

                    urlTo("android")
            } */
  }
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "50%",
      }}
    >
      <img
        style={{ marginLeft: "5%" }}
        src={require("./imge/protien.jpeg")}
        width={"75%"}
        height={"60%"}
      />
      <div
        style={{
          display: "flex",
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          marginLeft: "3%",
        }}
      >
        <div onClick={() => urlTo("android")}>
          <img
            src={require("./imge/google-play-badge.png")}
            width={"98%"}
            height={"100%"}
          />
        </div>
        <div onClick={() => urlTo("ios")}>
          <img
            src={require("./imge/applelogo.png")}
            width={"100%"}
            height={"100%"}
          />
        </div>
      </div>
    </div>
  );
}
